import { Component, HostListener, inject } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { GlobalOverlayService } from '../../../core/ui/global-overlay.service';

@Component({
  selector: 'app-global-overlay',
  imports: [LucideAngularModule],
  templateUrl: './global-overlay.component.html',
  styleUrl: './global-overlay.component.css',
})
export class GlobalOverlayComponent {
  readonly overlay = inject(GlobalOverlayService);

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.overlay.cancel();
  }
}
